import { styled } from '@compiled/react';

import { ButtonItem } from '@atlaskit/menu';
import { N800 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PopupMenuButton = styled(ButtonItem)<{
	isReverseTrialEnrolledVersion: boolean;
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
}>(({ isReverseTrialEnrolledVersion }) =>
	isReverseTrialEnrolledVersion
		? {}
		: {
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
				padding: `${token('space.100', '8px')} ${token('space.250', '20px')} !important`,
				minHeight: '44px',
				'& > span > span[data-item-elem-before="true"]': {
					marginRight: '-2px',
				},
				'& > span > span[data-item-elem-before="true"] + span': {
					minWidth: '213px',
					overflow: 'visible',
				},
			},
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const PopupMenuButtonText = styled.span({
	color: token('color.text', N800),
	whiteSpace: 'initial',
	wordWrap: 'break-word',
	lineHeight: '20px',
});
